exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".AQsJ {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center; }\n\n.yfL6 p {\n  font-size: 12px; }\n\n.FRNX {\n  font-weight: bold; }\n\n._3ruh {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n  ._3ruh p {\n    margin-right: 4px; }\n\n._3SC5 {\n  cursor: pointer;\n  margin-right: 32px;\n  color: #1e90ff; }\n  ._3SC5:hover {\n    text-decoration: underline;\n    color: #6bb6ff; }\n", ""]);

// exports
exports.locals = {
	"container": "AQsJ",
	"headerText": "yfL6",
	"adminText": "FRNX",
	"menuButtons": "_3ruh",
	"logoutLink": "_3SC5"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"namedExport":true,"localIdentName":"[hash:base64:4]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"data":"@import /"variables/";","includePaths":["/app/src/styles"]}!./src/pages/Admin/components/AdminHeader/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"namedExport":true,"localIdentName":"[hash:base64:4]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"data":"@import \"variables\";","includePaths":["/app/src/styles"]}!./src/pages/Admin/components/AdminHeader/styles.scss
// module chunks = 0